import { render, staticRenderFns } from "./WannasornLearningHistorySummaryReport.vue?vue&type=template&id=afaf7734"
import script from "./WannasornLearningHistorySummaryReport.vue?vue&type=script&lang=js"
export * from "./WannasornLearningHistorySummaryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports